import { IFactorSummaryPoint } from "../../../../../schema";

/**
 * Mean of the per-factor averages. A factor with no numeric answers (e.g. a text-only
 * custom factor) arrives with a null average and must not count toward the denominator.
 */
export const averageFactorSummaries = (points: IFactorSummaryPoint[]): number => {
	const averages = points
		.map((point) => point.average)
		.filter((average): average is number => typeof average === "number" && Number.isFinite(average));
	if (!averages.length) {
		return 0;
	}
	return averages.reduce((total, average) => total + average, 0) / averages.length;
};
